import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { QuestionnaireService } from "app/services/questionnaire.service";
import { NgxSpinnerService } from "ngx-spinner";
import { HelperService } from "app/services/helper.service";
import { ActivatedRoute } from "@angular/router";
import { TosterMessageService } from "app/services/toster-message.service";
import { QuestionBankService } from "../../services/question-bank.service";

import { UploadService } from "app/services/upload.service";

@Component({
  selector: "app-question-bank-edit-written-modal.component",
  templateUrl: "./question-bank-edit-written-modal.component.html",
  styleUrls: ["./question-bank-edit-written-modal.component.scss"],
  providers: [QuestionBankService],
})
export class QuestionBankEditWrittenModalComponent implements OnInit {
  public masterData: any = {};
  validateForm: FormGroup;

  isHide: any = 1;
  isLoading = false;

  id: number;
  header_id_2: number;
  message = "";

  formData: {
    media_type: "";
    media_link: "";
    storage_siz: "";
    answer: "";
    header_id: "";
    header_detail_id: "";
  }[] = [];

  questionHeader: {
    answer: "";
    marks: "";
    media_type: "";
    media_link: "";
  }[] = [];

  @Input() auto_id: number;

  isEdit: number;
  @ViewChild("swalModal") swalModal: any;
  @ViewChild("errorMessageHtml") errorMessageHtml: any;
  @ViewChild("f") form: any;
  @Output() tableReload: EventEmitter<any> = new EventEmitter();

  selectedFile: any = {};

  public successMsg: string = "";
  public htmlErrorMessage: string = "";
  selectedCompanySystemID = this.helperService.getSelectedCompanyId();
  companySystemID = this.helperService.getSelectedCompanyId();
  header_id = 1;
  header_detail_id = 1;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    public bsModalRef: BsModalRef,
    private helperService: HelperService,
    private modalService: BsModalService,
    private questionBankService: QuestionBankService,
    private UploadService: UploadService
  ) {}

  showErrorHtml() {
    setTimeout(() => {
      this.errorMessageHtml.show();
    }, 0);
  }

  closeModal() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("designation_closed");
  }

  closeModalAfterCreate() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("designation_closed");
  }

  showSuccessHtml() {
    setTimeout(() => {
      this.swalModal.show();
    }, 0);
  }

  ngOnInit() {
    this.validateForm = this.formBuilder.group({
      answer: [{ value: "" }, [Validators.required]],
      marks: [{ value: "" }, [Validators.required]],
      media_type: [0],
      media_link: [0],
    });

    this.auto_id = Number(localStorage.getItem("question-bank-edit-auto-id"));
    this.header_id_2 = Number(
      localStorage.getItem("question-bank-edit-header-id")
    );

    localStorage.removeItem("question-bank-edit-auto-id");
    localStorage.removeItem("question-bank-edit-header-id");
    this.getQuestionWrittenMcq(this.header_id_2);

    localStorage.removeItem("file");
    setInterval(() => {
      if (localStorage.getItem("file")) {
        this.isLoading = false;
      }
    }, 1500);
  }

  getQuestionWrittenMcq(header_id_2: number) {
    this.questionBankService
      .getQuestionAnsMcq(this.header_id_2)
      .get()
      .subscribe((resp) => {
        const data = resp.data.data;
        this.questionHeader = data;
        this.validateForm.get("answer").patchValue(data.answer);
        this.validateForm.get("marks").patchValue(data.marks);
        this.validateForm.get("media_type").patchValue(data.media_type);
        this.validateForm.get("media_link").patchValue(data.media_link);
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.isLoading = false;
  }

  async onFileSelected(event: any) {
    this.isLoading = true;
    this.selectedFile = event.target.files[0];
    const response = await this.UploadService.uploadFile(this.selectedFile);
  }


  // onMediaTypeChange(event: Event) {
  //   const selectedValue = (event.target as HTMLSelectElement).value;
  //   console.log(selectedValue);
  
  //   if (selectedValue !== "1") {
  //     this.isHide = 0;
  //   } else {
  //     this.isHide = 1;
  //   }
  // }
  


  updateWrittenAns() {
    const requestData = {
      answer: this.validateForm.get("answer").value,
      marks: this.validateForm.get("marks").value,
      media_type: this.validateForm.get("media_type").value,
      media_link: localStorage.getItem("file"),
      header_id: this.header_id_2,
    };
    localStorage.removeItem("file");

    let that = this;
    this.questionBankService
      .updateQuestionAnsMcq(this.header_id_2)
      .customPUT(requestData)
      .subscribe(
        (resp: any) => {
          this.successMsg = "Successfully updated written question";
          this.spinner.show();
          this.tableReload.emit();
          this.showSuccessHtml();
          this.closeModalAfterCreate();
          this.tableReload.emit();
          this.spinner.hide();
          this.tableReload.emit();
        },
        (error) => {
          that.htmlErrorMessage = "";
          if (error.status == 500) {
            that.htmlErrorMessage = error.data.message;
            that.showErrorHtml();
          } else if (error.status == 422) {
            that.htmlErrorMessage = that.helperService.serverSideError422(
              error.data.message
            );
            that.showErrorHtml();
          }
          this.tableReload.emit();
        }
      );
    this.tableReload.emit();
  }
}



// WEBPACK FOOTER //
// /app/src/app/competancy/question-bank-edit-written-modal/question-bank-edit-written-modal.component.ts